import { render } from "./BadgetInfo.vue?vue&type=template&id=6601a4c3"
import script from "./BadgetInfo.vue?vue&type=script&lang=js"
export * from "./BadgetInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__